export default "__VITE_ASSET__pzK6nY5K__"